import React from 'react';
import tpl from '../templates/acquiring.c.jsx';
import BaseNewCardView from '../../Cards/views/BaseNewCardView';
import {canUseDOM} from '../../../helpers/canUseDOM';
import {getScrollBehavior} from '../../../helpers/utils/scrollBehavior';

const BASE_PATH = '/business/acquiring';
const ORDER_SEGMENT = 'order';
const ORDER_SELECTOR = '#top-tabs .tabs-new__content.active .how-to-block-new';
const TABS = ['taptophone', 'pos', 'qr', 'internet', 'vending'];

// /business/acquiring[/<tab>][/order] -> {tab, isOrder}; 'review' tab is the bare /business/acquiring
const getRouteState = props => {
    const pathname = (props.location && props.location.pathname) || '';
    const segments = pathname.split('/').filter(Boolean);
    const baseIndex = segments.indexOf('acquiring');
    const rest = baseIndex === -1 ? [] : segments.slice(baseIndex + 1);

    return {
        pathname,
        tab: TABS.includes(rest[0]) ? rest[0] : 'review',
        isOrder: rest[rest.length - 1] === ORDER_SEGMENT
    };
};

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props, context) {
        super(props, context);

        const ssrData = context && context.ssrData;

        this.state = {
            ...this.state,
            search_by: [BASE_PATH],
            tab: getRouteState(props).tab,
            internetIntegrationTab: 'fiscalization',
            widgets_taptophone: (ssrData && ssrData.widgets_taptophone) || [],
            widgets_pos: (ssrData && ssrData.widgets_pos) || [],
            widgets_qr: (ssrData && ssrData.widgets_qr) || [],
            widgets_internet: (ssrData && ssrData.widgets_internet) || [],
            widgets_vending: (ssrData && ssrData.widgets_vending) || []
        };
    }

    componentDidUpdate(prevProps) {
        const {pathname, tab, isOrder} = getRouteState(this.props);

        if (pathname === getRouteState(prevProps).pathname) return;

        if (tab !== this.state.tab) {
            this.setState({tab}, () => isOrder && this.scrollToOrderBlock());
        } else if (isOrder) {
            this.scrollToOrderBlock();
        }
    }

    scrollToOrderBlock = () => {
        this.waitForElement(ORDER_SELECTOR, element => {
            element.scrollIntoView({behavior: getScrollBehavior(), block: 'start'});
        });
    };

    toggleTab = tab => {
        this.setState({tab});

        const path = tab === 'review' ? BASE_PATH : `${BASE_PATH}/${tab}`;

        if (canUseDOM && window.location.pathname !== path) {
            this.navigateKeepScroll(path);
        }
    };

    toggleInternetIntegrationTab = tab => {
        this.setState({internetIntegrationTab: tab});
    };

    navigateAndScrollToContent = (path, e) => {
        this.navigate(path, e);
        this.scrollToContent();
    };

    navigateKeepScroll = (path, e) => {
        return this.navigate(path, e, {state: {preventScroll: true}});
    };

    componentDidMount() {
        super.componentDidMount();

        if (getRouteState(this.props).isOrder) {
            this.scrollToOrderBlock();
        }

        ['taptophone', 'pos', 'qr', 'internet', 'vending'].forEach(tab => {
            const widgetKey = `widgets_${tab}`;

            // widgets already prefetched on the server (see dataFetchers) do not need to be requested again
            if (this.state[widgetKey].length === 0) {
                this.widgetsHelper.getWidgetsByPath.call(this, {
                    path: `${BASE_PATH}/${tab}`,
                    widgetKey
                });
            }
        });
    }

    static displayName = 'Business.Views.Acquiring';
}
